import {PATH_SLASH} from 'const';
import escapeFile from 'sanitize-filename';

export const scaleSize = (initialV: number, totalV: number, currentV: number) => {
   const res = (initialV * currentV) / totalV;

   return res;
};

export const buildPath = (path: string, name: string) => {
   if (path[path.length - 1] === PATH_SLASH) return path + name;
   return path + PATH_SLASH + name;
};

export const escapeFileName = (file: string) => escapeFile(file.trim(), {replacement: '_'});

export function getFileName(path: string) {
   const lastSlash = path.lastIndexOf('/');
   const parentPath = path.slice(0, lastSlash) || '/';
   const name = path.slice(lastSlash + 1, path.length);
   console.debug('get last folder', path, parentPath, name);
   return {parentPath, name};
}
